export default {
  YEARS_KNOWING_COLUMBUS_REPOSITORY: Symbol.for('YEARS_KNOWING_COLUMBUS_REPOSITORY'),
  GET_ALL_YEARS_KNOWING_COLUMBUS_QUERY: Symbol.for('GET_ALL_YEARS_KNOWING_COLUMBUS_QUERY'),
  YEARS_KNOWING_COLUMBUS_STATE_MANAGER: Symbol.for('YEARS_KNOWING_COLUMBUS_STATE_MANAGER'),
};
